import type {ThemeMode} from '@/store/slices/theme'

const LIGHT_APP_ICON_PATH = '/images/devlens-logo-light.svg'
const DARK_APP_ICON_PATH = '/images/devlens-logo-dark.svg'

const getAppIconPath = (mode: ThemeMode): string => (mode === 'dark' ? DARK_APP_ICON_PATH : LIGHT_APP_ICON_PATH)

export const syncAppIconWithTheme = (mode: ThemeMode): void => {
  if (typeof document === 'undefined') return

  const href = getAppIconPath(mode)
  let iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]')

  if (!iconLink) {
    iconLink = document.createElement('link')
    iconLink.rel = 'icon'
    iconLink.type = 'image/svg+xml'
    document.head.appendChild(iconLink)
  }

  iconLink.href = href
}
